const f = (r, o = {}) => {
  try {
    const a = new URL(r);
    return Object.entries(o).forEach(([t, e]) => {
      ["string", "number", "boolean"].includes(typeof e) && a.searchParams.set(t, e.toString());
    }), a.toString();
  } catch {
    return "";
  }
};
var u = /* @__PURE__ */ ((r) => (r.LOCAL = "local", r.SESSION = "session", r))(u || {});
const S = (r) => {
  try {
    return JSON.parse(r);
  } catch {
    return r;
  }
};
function y({
  key: r,
  type: o = "session"
  /* SESSION */
}) {
  try {
    const t = (o === "local" ? window.localStorage : window.sessionStorage).getItem(r);
    return t ? S(t) : null;
  } catch {
    return console.warn("We can not get the data from storage"), null;
  }
}
function h({
  data: r,
  type: o = "session",
  key: a
}) {
  const t = JSON.stringify(r);
  try {
    (o === "local" ? window.localStorage : window.sessionStorage).setItem(a, t);
  } catch {
    console.warn("We can not set data into your storage");
  }
}
const m = (r) => ({ ok: !0, val: r }), k = (r) => ({
  ok: !1,
  error: r
}), q = (r) => r instanceof FormData ? r : JSON.stringify(r);
async function O(r, {
  signal: o,
  body: a = null,
  headers: t = {},
  method: e = "GET",
  keyAccessToken: l,
  keyBecomeToken: c,
  statusCodeToCheck: n,
  onAuthorizationError: i,
  queryParameters: w = {}
} = {
  body: null,
  headers: {},
  queryParameters: {}
}) {
  const d = y({
    type: (l == null ? void 0 : l.type) || u.LOCAL,
    key: (l == null ? void 0 : l.name) || ""
  }) || null, g = y({
    type: (c == null ? void 0 : c.type) || u.LOCAL,
    key: (c == null ? void 0 : c.name) || ""
  }) || null, p = {
    method: e,
    ...a ? { body: q(a) } : {},
    headers: {
      ...a instanceof FormData ? {} : { "Content-Type": "application/json" },
      Accept: "application/json",
      "X-Requested-With": "XMLHttpRequest",
      ...d ? {
        "Access-Token": d
      } : {},
      ...g ? {
        "Become-Creator-Id": g
      } : {},
      ...t
    }
  }, v = f(r, w);
  try {
    const s = await fetch(v, {
      ...p,
      ...o ? { signal: o } : {}
    });
    return s.status === 401 ? (i == null || i(), k({
      url: v,
      request: p,
      status: s.status,
      response: s
    })) : !s.ok || n && n !== s.status ? k({
      url: v,
      request: p,
      status: s.status,
      response: s
    }) : m(s);
  } catch (s) {
    return k({
      url: v,
      request: p,
      status: 500,
      response: s
    });
  }
}
const L = async ({
  event: r,
  endpoint: o,
  properties: a,
  accessTokenSetup: t
}) => {
  const e = JSON.stringify({
    event: r,
    properties: a
  }), { key: l, type: c } = t, n = y({
    key: l,
    type: c
  }) || "";
  await fetch(o, {
    body: e,
    method: "POST",
    keepalive: !0,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Token": n
    }
  });
}, j = {
  neutral: {
    50: "var(--skp-color-neutral-50)",
    100: "var(--skp-color-neutral-100)",
    200: "var(--skp-color-neutral-200)",
    300: "var(--skp-color-neutral-300)",
    400: "var(--skp-color-neutral-400)",
    500: "var(--skp-color-neutral-500)",
    600: "var(--skp-color-neutral-600)",
    700: "var(--skp-color-neutral-700)",
    800: "var(--skp-color-neutral-800)",
    900: "var(--skp-color-neutral-900)"
  },
  primary: {
    50: "var(--skp-color-primary-50)",
    100: "var(--skp-color-primary-100)",
    200: "var(--skp-color-primary-200)",
    300: "var(--skp-color-primary-300)",
    400: "var(--skp-color-primary-400)",
    500: "var(--skp-color-primary-500)",
    600: "var(--skp-color-primary-600)",
    700: "var(--skp-color-primary-700)",
    800: "var(--skp-color-primary-800)",
    900: "var(--skp-color-primary-900)"
  },
  secondary: {
    50: "var(--skp-color-secondary-50)",
    100: "var(--skp-color-secondary-100)",
    200: "var(--skp-color-secondary-200)",
    300: "var(--skp-color-secondary-300)",
    400: "var(--skp-color-secondary-400)",
    500: "var(--skp-color-secondary-500)",
    600: "var(--skp-color-secondary-600)",
    700: "var(--skp-color-secondary-700)",
    800: "var(--skp-color-secondary-800)",
    900: "var(--skp-color-secondary-900)"
  },
  tertiary: {
    50: "var(--skp-color-tertiary-50)",
    100: "var(--skp-color-tertiary-100)",
    200: "var(--skp-color-tertiary-200)",
    300: "var(--skp-color-tertiary-300)",
    400: "var(--skp-color-tertiary-400)",
    500: "var(--skp-color-tertiary-500)",
    600: "var(--skp-color-tertiary-600)",
    700: "var(--skp-color-tertiary-700)",
    800: "var(--skp-color-tertiary-800)",
    900: "var(--skp-color-tertiary-900)"
  },
  quaternary: {
    50: "var(--skp-color-quaternary-50)",
    100: "var(--skp-color-quaternary-100)",
    200: "var(--skp-color-quaternary-200)",
    300: "var(--skp-color-quaternary-300)",
    400: "var(--skp-color-quaternary-400)",
    500: "var(--skp-color-quaternary-500)",
    600: "var(--skp-color-quaternary-600)",
    700: "var(--skp-color-quaternary-700)",
    800: "var(--skp-color-quaternary-800)",
    900: "var(--skp-color-quaternary-900)"
  },
  success: {
    50: "var(--skp-color-success-50)",
    100: "var(--skp-color-success-100)",
    200: "var(--skp-color-success-200)",
    300: "var(--skp-color-success-300)",
    400: "var(--skp-color-success-400)",
    500: "var(--skp-color-success-500)",
    600: "var(--skp-color-success-600)",
    700: "var(--skp-color-success-700)",
    800: "var(--skp-color-success-800)",
    900: "var(--skp-color-success-900)"
  },
  warning: {
    50: "var(--skp-color-warning-50)",
    100: "var(--skp-color-warning-100)",
    200: "var(--skp-color-warning-200)",
    300: "var(--skp-color-warning-300)",
    400: "var(--skp-color-warning-400)",
    500: "var(--skp-color-warning-500)",
    600: "var(--skp-color-warning-600)",
    700: "var(--skp-color-warning-700)",
    800: "var(--skp-color-warning-800)",
    900: "var(--skp-color-warning-900)"
  },
  error: {
    50: "var(--skp-color-error-50)",
    100: "var(--skp-color-error-100)",
    200: "var(--skp-color-error-200)",
    300: "var(--skp-color-error-300)",
    400: "var(--skp-color-error-400)",
    500: "var(--skp-color-error-500)",
    600: "var(--skp-color-error-600)",
    700: "var(--skp-color-error-700)",
    800: "var(--skp-color-error-800)",
    900: "var(--skp-color-error-900)"
  },
  alternative1: {
    50: "var(--skp-color-alternative1-50)",
    100: "var(--skp-color-alternative1-100)",
    200: "var(--skp-color-alternative1-200)",
    300: "var(--skp-color-alternative1-300)",
    400: "var(--skp-color-alternative1-400)",
    500: "var(--skp-color-alternative1-500)",
    600: "var(--skp-color-alternative1-600)",
    700: "var(--skp-color-alternative1-700)",
    800: "var(--skp-color-alternative1-800)",
    900: "var(--skp-color-alternative1-900)"
  },
  alternative2: {
    50: "var(--skp-color-alternative2-50)",
    100: "var(--skp-color-alternative2-100)",
    200: "var(--skp-color-alternative2-200)",
    300: "var(--skp-color-alternative2-300)",
    400: "var(--skp-color-alternative2-400)",
    500: "var(--skp-color-alternative2-500)",
    600: "var(--skp-color-alternative2-600)",
    700: "var(--skp-color-alternative2-700)",
    800: "var(--skp-color-alternative2-800)",
    900: "var(--skp-color-alternative2-900)"
  },
  alternative3: {
    50: "var(--skp-color-alternative3-50)",
    100: "var(--skp-color-alternative3-100)",
    200: "var(--skp-color-alternative3-200)",
    300: "var(--skp-color-alternative3-300)",
    400: "var(--skp-color-alternative3-400)",
    500: "var(--skp-color-alternative3-500)",
    600: "var(--skp-color-alternative3-600)",
    700: "var(--skp-color-alternative3-700)",
    800: "var(--skp-color-alternative3-800)",
    900: "var(--skp-color-alternative3-900)"
  }
};
export {
  k as Err,
  m as Ok,
  u as STORAGE_TYPE,
  L as addEvent,
  f as addQueryParametersToUrl,
  j as colors,
  O as fetchAPI,
  y as getWindowStorage,
  S as parser,
  h as setWindowStorage
};
